/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab.ts";
import { courseRegistrationManagementScholarshipItemViewModelSchema } from "../courseRegistrationManagementScholarshipItemViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab200Schema =
  z.array(
    z.lazy(() => courseRegistrationManagementScholarshipItemViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTab200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidScholarshipTabQueryResponse>;
